<template>
  <div class="box">
    <div class="box_title_add">
      <span>创建</span>
      <img src="@/assets/xxx.png" alt="" @click="close">
    </div>
    <div class="content">
     
      <div class="right">
        <div class="bottom" >
            <div v-for="(item,index) in aboutIndex[0]" @click="bootxing(index)" :key="index">
              {{index+1}}
            </div>
        </div>
        <div class="topsright">
          <img src="@/assets/ge.png" alt="">
          <p>舞台方向</p>
        </div>
        <div class="gezi" v-if="form.area_type==1">
          <div class="sort">
              <div v-for="(item,index) in aboutIndex" @click="hangxing(index)" :key="index">
                {{index+1}}
              </div>
          </div>
         
          <div class="fore">
            <div v-for="(item,index) in aboutIndex" :key="index" >
              <div v-for="(itm,idx) in item" :class="itm.act==2?'SelectCss':''" :key="idx" class="content_gezi" @click="changeClick(itm)">
              </div>
            </div>
            <div  class="bottom_img">
              <img src="@/assets/cina/topadd.png" alt="" @click="reducebtns">
              <img src="@/assets/cina/bottomadd.png" alt=""  @click="addXia">
            </div>
            <div class="right_img">
              <img src="@/assets/cina/leftadd.png" alt=""  @click="reduceLeft">
              <img src="@/assets/cina/rightadd.png" alt="" @click="addZuo">
            </div>
            <!-- <img src="@/assets/xia.png" alt="" class="bottom_img" @click="addXia">
            <img src="@/assets/zuo.png" alt="" class="right_img"  @click="addZuo"> -->
          </div>
        </div>
        <div class="gezi" v-if="form.area_type==2">
          <div class="sort">
              <div v-for="(item,index) in aboutIndex" @click="hangxing1(index)"  :key="index">
                {{index}}  
              </div>
          </div>
          <div class="fore">
            <div v-for="(item,index) in aboutIndex" :key="index" >
              <div v-for="(itm,idx) in item" :class="itm.act==2?'SelectCss':''" :key="idx" class="content_gezi" @click="changeClick(itm)">
              </div>
            </div>
            <!-- <img src="@/assets/xia.png" alt=""> -->
            <!-- <img src="@/assets/zuo.png" alt="" class=""  > -->
            <div  class="bottom_img">
              <img src="@/assets/cina/topadd.png" alt=""  @click="reducebtns">
              <img src="@/assets/cina/bottomadd.png" alt="" @click="addXia">
            </div>
            <div class="right_img">
              <img src="@/assets/cina/leftadd.png" alt="" @click="reduceLeft">
              <img src="@/assets/cina/rightadd.png" alt="" @click="addZuo">
            </div>
          </div>
        </div>
        <div class="gezi" v-if="form.area_type==3">
        </div>
      </div>
      <div class="left">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="区域分类：">
              <el-radio-group v-model="form.area_type" @change="switchTab">
                <el-radio label="1">选座</el-radio>
                <el-radio label="2">包房</el-radio>
                <el-radio label="3">无座</el-radio>
              </el-radio-group>
          </el-form-item>
          <div class="flex" v-if="form.area_type!=3">
            <el-form-item label="总列数：">
              <el-input v-model="form.area_column" disabled @change="inputColumn"></el-input>
            </el-form-item>
            <el-form-item label="总行数：">
              <el-input v-model="form.area_row" disabled @change="inputRow"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="区域名称：">
              <el-input v-model="form.area_name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="座位数量：" v-if="form.area_type!=3">
            <span class="form_text">{{num}}</span>
          </el-form-item>
          <el-form-item label="选择座位：" v-if="form.area_type!=3">
            <div class="seat">
                <div v-for="(item,index) in numArr" :key="index">
                  {{index+1}}排： <span>{{item.index}}</span>
                </div>
            </div>
          </el-form-item>
          <el-form-item label="入场人数：" v-if="form.area_type==3">
              <el-input v-model="num" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div class="operation">
          <div @click="submitBtn">确认保存</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addMovieArea , getMovieAreaInfo , updateMovieArea } from '@/request/scenic.js'
export default {
  data(){
    return{
      form:{
        token:window.sessionStorage.getItem('Token'),
        area_name:'',
        area_type:'1',
        area_column:15,
        area_row:15,
        seat:[
        ]
      },
      lowerIndex:15,
      aboutIndex:[],
      numArr:[{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},
      {index:0},{index:0},{index:0},{index:0},{index:0}],
      num:''
    }
  },
  created(){
      if(this.$route.query.id){
        this.getInfo()
      }else{
        for(let i=0;i<this.lowerIndex;i++){
          this.aboutIndex.push(
            [{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},]
          )
        }
        this.num = this.form.area_column*this.form.area_row
      }
  },
  methods:{
    bootxing(e){
      this.aboutIndex.map((item,index)=>{
          item.map((itm,idx)=>{
            if(e==idx){
              itm.act = 2
            }
          })
      })
    },
    hangxing1(e){
      this.aboutIndex[e].map(item=>{
          item.act = 2
      })
    },
    hangxing(e){
      console.log(e,this.aboutIndex)
      this.aboutIndex[e].map(item=>{
          item.act = 2
      })
    },
    inputRow(e){
      let num = e - this.aboutIndex.length
      for(let i=0;i<num;i++){
        this.aboutIndex.push(
          []
        )
        for(let j=0;j<this.aboutIndex[i].length;j++){
          this.aboutIndex[this.aboutIndex.length-1].push({act:'1'})
        }
      }
    },
    inputColumn(e){
    },
    getInfo(){
      let data = {
        id:this.$route.query.id,
        token:window.sessionStorage.getItem('Token')
      } 
      getMovieAreaInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.form={
            token:window.sessionStorage.getItem('Token'),
            area_name:res.data.result.area_name,
            area_type:res.data.result.area_type + '',
            area_column:res.data.result.area_column,
            area_row:res.data.result.area_row,
            seat:res.data.result.movie_seats
          }
          if(res.data.result.area_column!=0){
            this.num = res.data.result.area_column*res.data.result.area_row
          }else{
            this.num = res.data.result.seat_num
          }
          for(let i=0;i<res.data.result.area_row;i++){
            this.aboutIndex[i] = []
            for(let j=0;j<res.data.result.area_column;j++){
              this.aboutIndex[i].push({
                act:1
              })
            }
          }
          this.aboutIndex.map((item,index)=>{
            item.map((info,idx)=>{
              res.data.result.movie_seats.map(movie=>{
                if(movie.column==idx+1&&movie.row==index+1){
                    info.act = 2,
                    info.id = movie.id
                }
              })
            })
          })
        }
      })
    },
    submitBtn(){
      if(this.form.area_name==''){
        this.$message.error('请输入区域名称')
        return false
      }
      let option = []
      this.aboutIndex.map((item,index)=>{
        item.map((itm,idx)=>{
          if(itm.act==2){
            option.push({
              column:idx+1,
              row:index+1
            })
          }
        })  
      })
      this.form.seat_num = this.num
      this.form.seat = option
      if(this.$route.query.id){
        let arr = []
        this.aboutIndex.map((item,index)=>{
          item.map((itm,idx)=>{
            if(itm.act==2&&!itm.id){
              arr.push({
                column:idx+1,
                row:index+1
              })
            }
          })  
        })
        this.form.addseat = arr
        this.form.id = this.$route.query.id
        let ids = ''
        this.aboutIndex.map(item=>{
          item.map(info=>{
            if(info.act==3&&info.id){
              ids += info.id + ','
            }
          })
        })
        ids = ids.slice(0,-1)
        this.form.delseatids = ids
        if(this.form.area_type=='1'||this.form.area_type=='2'){
          if(this.form.seat.length==0){
            this.$message.error('请选择区域位置')
            return false
          }
        }
        updateMovieArea(this.form).then(res=>{
          if(res.data.status=='ok'){
              this.$message.success('修改区域成功')
              this.$router.push({
                path:'cinema',
                query:{
                  sort:2
                }
              })
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }else{
        console.log(this.form.area_type)
        if(this.form.area_type=='1'||this.form.area_type=='2'){
          if(this.form.seat.length==0){
            this.$message.error('请选择区域位置')
            return false
          }
        }
        addMovieArea(this.form).then(res=>{
          if(res.data.status=='ok'){
              this.$message.success('添加区域成功')
              // this.$router.go(-1)
              this.$router.push({
                path:'cinema',
                query:{
                  sort:2
                }
              })
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }
      
    },
    close(){
      this.$router.go(-1)
    },
    switchTab(e){
      if(e==2){
        this.aboutIndex = []
        this.lowerIndex = 2
        for(let i=0;i<this.lowerIndex;i++){
          this.aboutIndex.push(
            [{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'}]
          )
        }
        this.numArr = [{index:0},{index:0}]
        this.form.area_column = 5
        this.form.area_row = 2
        this.num = this.form.area_column * this.form.area_row
      }else if(e==1){
        this.aboutIndex = []
        this.lowerIndex = 15
        for(let i=0;i<this.lowerIndex;i++){
          this.aboutIndex.push(
            [{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},{act:'1'},]
          )
        }
        this.form.area_column = 15
        this.form.area_row = 15
        this.numArr = [{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},{index:0},
        {index:0},{index:0},{index:0},{index:0},{index:0}]
      }else{
        this.num = 0
      }
    },
    changeClick(im){
      if(im.act==1){
        im.act = 2
      }else{
        im.act = 1
      }
      this.numArr = []
      this.aboutIndex.map(item=>{
        let nums = 0
        item.map(itm=>{
          if(itm.act==2){
            nums += 1
          }
        })
        this.numArr.push({
          index:nums
        })
      })
    },
    reducebtns(){
      for(let i=0;i<this.aboutIndex[this.aboutIndex.length-1].length;i++){
        if(this.aboutIndex[this.aboutIndex.length-1][i].act==2){
           this.$message.error('请取消最后一行已选数据')
           return false
        }
      }
      this.aboutIndex.splice(this.aboutIndex.length-1,1)
      this.form.area_row -= 1
      this.num = this.form.area_column*this.form.area_row
    },
    addXia(){
      if(this.lowerIndex<this.aboutIndex[0].length){
        this.lowerIndex +=1
      }
      this.numArr.push({
          index:0
      })
      this.form.area_row += 1
      this.num = this.form.area_column*this.form.area_row
      for(let i=0;i<this.lowerIndex;i++){
        this.aboutIndex.push(
          []
        )
        for(let j=0;j<this.aboutIndex[i].length;j++){
          this.aboutIndex[this.aboutIndex.length-1].push({act:'1'})
        }
        return false
      }
    },
    reduceLeft(){
      for(let i=0;i<this.aboutIndex.length;i++){
          for(let j=0;j<this.aboutIndex[i].length;j++){
              if(this.aboutIndex[i][this.aboutIndex[i].length-1].act==2){
                this.$message.error('请取消最后一列已选数据')
                return false
              }
          }
      }
      this.aboutIndex.map(item=>{
        item.pop()
      })
      this.form.area_column -=1
      this.num = this.form.area_column*this.form.area_row
    },
    addZuo(){
      this.lowerIndex +=1
      for(let i=0;i<this.aboutIndex.length;i++){
        let arr = this.aboutIndex[i]
        arr.push({
          act:'1'
        })
        this.aboutIndex[i]  = arr
      }
      this.form.area_column +=1
      this.num = this.form.area_column*this.form.area_row
    }
  }
}
</script>
<style lang="less" scoped>
.box_title_add{
  padding: 1.8rem 0;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #E5E5EA;
  >span{
    color: #000000;
    font-size: 2rem;
    font-weight: 600;
  }
  img{
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translate(-50%,0);
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
}
.box{
  padding: 0 2rem;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  .content{
    padding: 2rem 0;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    .right{
      width: 120rem;
      height: 100%;
      background: #E5E5EA;
      position: relative;
      .topsright{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img{
          width: 34.5rem;
          height: 1.4rem;
        }
        p{
          margin-top: 2.4rem;
          color: #0059EF;
          font-size: 2.2rem;
        }
      }
      .gezi{
        margin-top: 2rem;
        display: flex;
        justify-content: center;
        position: relative;
        padding: 4rem 4rem 7  rem 4rem;
        box-sizing: border-box;
        .sort{
          display: flex;
          flex-direction: column;
          position: absolute;
          left: 2rem;
          div{
            width: 3rem;
            height: 3rem;
            margin-bottom: 0.2rem;
            cursor: pointer;
          }
        }
        .fore{
          position: relative;
          >div{
            position: relative;
            display: flex;
            .content_gezi{
              width: 3rem;
              height: 3rem;
              border: 1px solid #B2B2B2;
              border-radius: 0.4rem;
              background: #F7F7FA;
              margin-right: 0.2rem;
              margin-bottom: 0.2rem;
              cursor: pointer;
            }
          }
      
          .bottom_img{
            position: absolute;
            bottom:-3rem;
            left: 50%;
            transform: translate(-50%,0);    img{
            width: 3rem;
            height: 3rem;
            cursor: pointer;
          }
          }
          .right_img{
            position: absolute;
            top: 50%;
            right:-3rem;
            transform: translate(0,-50%);
            display: flex;
            flex-direction: column;    img{
            width: 3rem;
            height: 3rem;
            cursor: pointer;
          }
          }
        }
        
      }
    }
    .left{
      flex: 1;
      margin-left: 2rem;
      position: relative;
      .form_text{
        color: #0059EF;
        font-size: 1.4rem;
      }
      .seat{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        div{
          width: 50%;
          color: #666666;
          font-size: 1.4rem;
          span{
            color: #666666;
            font-weight: 600;
          }
        }
      }
      .operation{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 6rem;
        // position: absolute;
        // bottom: 6rem;
        // left: 50%;
        // transform: translate(-50%,0);
        div{
          width: 10rem;
          height: 4rem;
          border-radius: 0.4rem;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;
          font-size: 1.4rem;
          cursor: pointer;
          background: #246DEB;
        }
      }
    }
  }
}
.SelectCss{
  border: 1px solid #0059EF !important;
  background: #D4E3FA !important; 
}
.flex{
  display: flex;
}
.bottom{
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%,0);
  display: flex;
  >div{
    width: 3rem;
    margin-right: 0.2rem;
    cursor: pointer;
    text-align: center;
  }
}
</style>